"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forecastCategoryOf = forecastCategoryOf;
exports.weightedValue = weightedValue;
exports.isRotting = isRotting;
exports.daysBetween = daysBetween;
exports.isSlipped = isSlipped;
exports.countsTowardValue = countsTowardValue;
exports.mondayOf = mondayOf;
exports.addDays = addDays;
exports.quarterOf = quarterOf;
exports.planMargin = planMargin;
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 20 Oct 2026 · PHASE 6 · the rules a deal's figures follow — one copy,     │
 * │ read by the service and the screens alike.                                │
 * └───────────────────────────────────────────────────────────────────────────┘
 */
/**
 * ⚠️ The mockup's settings, verbatim: *"A kategória alapból a valószínűségből származik (≥75% →
 * Bekötött, ≥40% → Legjobb eset, alatta Pipeline), de kézzel felülírható"*. An override wins.
 */
function forecastCategoryOf(probability, override) {
    if (override !== null)
        return override;
    if (probability >= 75)
        return 'commit';
    if (probability >= 40)
        return 'best_case';
    return 'pipeline';
}
/** Value × probability, to the fillér. An omitted deal weighs nothing in the forecast. */
function weightedValue(value, probability) {
    return Math.round(value * (probability / 100) * 100) / 100;
}
/**
 * ⚠️ *Rothadó*: an OPEN deal that has sat in its status longer than the status allows. A status
 * with no limit (0) never rots, and a closed deal never does.
 */
function isRotting(category, daysInStage, rotDays) {
    return category === 'open' && rotDays > 0 && daysInStage > rotDays;
}
/** Whole days between two instants, never negative. */
function daysBetween(from, to) {
    return Math.max(0, Math.floor((to.getTime() - from.getTime()) / 86_400_000));
}
/**
 * ⚠️ *Csúszott*: an open deal whose expected close date was ever moved LATER, or is already past.
 */
function isSlipped(category, closeDate, today, movedLater) {
    if (category !== 'open')
        return false;
    return movedLater || (closeDate !== null && closeDate < today);
}
/**
 * The line items that count toward a deal's value and plan: every type but an OPTION, which is
 * offered and not yet taken (the mockup's *opció* line, drawn but left out of the Σ).
 */
function countsTowardValue(type) {
    return type !== 'option';
}
/** The Monday of a calendar date's week, as `YYYY-MM-DD`. */
function mondayOf(date) {
    const [y = 1970, m = 1, d = 1] = date.split('-').map(Number);
    const at = new Date(Date.UTC(y, m - 1, d));
    const dow = at.getUTCDay() === 0 ? 7 : at.getUTCDay();
    at.setUTCDate(at.getUTCDate() - (dow - 1));
    return at.toISOString().slice(0, 10);
}
/** `YYYY-MM-DD` plus `days`. */
function addDays(date, days) {
    const [y = 1970, m = 1, d = 1] = date.split('-').map(Number);
    const at = new Date(Date.UTC(y, m - 1, d + days));
    return at.toISOString().slice(0, 10);
}
/** The quarter a date is in, as `2026-Q4`, and its first and last day. */
function quarterOf(date) {
    const [y = 1970, m = 1] = date.split('-').map(Number);
    const q = Math.floor((m - 1) / 3);
    const fromMonth = q * 3 + 1;
    const from = `${String(y)}-${String(fromMonth).padStart(2, '0')}-01`;
    const end = new Date(Date.UTC(y, fromMonth - 1 + 3, 0));
    return { label: `${String(y)}-Q${String(q + 1)}`, from, to: end.toISOString().slice(0, 10) };
}
/**
 * A plan's money in one place: labour cost is Σ hours × the placeholder's rate (× headcount is
 * already in the hours, since a two-person placeholder is allocated both people's hours).
 */
function planMargin(revenue, laborCost, externalCost) {
    const margin = Math.round((revenue - laborCost - externalCost) * 100) / 100;
    return { margin, marginPct: revenue > 0 ? margin / revenue : null };
}
//# sourceMappingURL=rules.js.map